var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 303,
    viewBox: "0 0 315 303",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5114_4257)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5114_4257",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 315,
    height: 303
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M315 0H0V303H315V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5114_4257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.794 153.51C254.113 136.601 252.717 119.287 253.26 101.989C253.293 100.941 253.309 99.8886 253.309 98.8322C253.309 44.2486 209.061 0 154.477 0C116.288 0 83.1582 21.6608 66.7022 53.3665C62.2158 62.0106 54.3216 68.3494 44.973 71.0795C19.1928 78.6082 0.359375 102.421 0.359375 130.634C0.359375 164.895 28.1335 192.669 62.3946 192.669C62.4625 192.669 62.5304 192.669 62.5981 192.669C73.5638 192.633 83.4831 199.085 87.9335 209.108C101.899 240.557 133.401 262.492 170.027 262.5C219.665 262.511 259.778 222.466 259.848 172.829C259.858 166.197 259.149 159.733 257.794 153.51Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.965 96.4299L123.243 58.7074C121.655 57.2141 119.549 56.3975 117.369 56.4307C115.19 56.4638 113.109 57.3442 111.567 58.8851C110.026 60.4261 109.145 62.5067 109.111 64.6861C109.077 66.8655 109.893 68.9725 111.385 70.5607L95.2109 86.7353L132.933 124.458L149.108 108.283C150.68 109.856 152.812 110.739 155.035 110.74C156.136 110.74 157.226 110.523 158.243 110.102C159.261 109.681 160.185 109.064 160.963 108.286C161.742 107.507 162.36 106.583 162.781 105.566C163.202 104.549 163.419 103.459 163.42 102.358C163.42 101.257 163.203 100.167 162.782 99.1499C162.361 98.1327 161.744 97.2085 160.965 96.4299Z",
    fill: "#ABDCC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.243 59.7074L121.928 58.979L121.939 58.9895L121.95 59.0003L121.243 59.7074ZM109.385 71.5607L110.114 70.8758L110.778 71.5823L110.093 72.2678L109.385 71.5607ZM93.2111 87.7353L92.504 88.4424L91.7969 87.7353L92.504 87.0281L93.2111 87.7353ZM130.933 125.458L131.641 126.165L130.933 126.872L130.226 126.165L130.933 125.458ZM147.108 109.283L146.401 108.576L147.108 107.869L147.815 108.576L147.108 109.283ZM158.258 98.137L120.536 60.4146L121.95 59.0003L159.673 96.7228L158.258 98.137ZM120.558 60.4359C119.159 59.1206 117.304 58.4013 115.384 58.4306L115.354 56.4308C117.793 56.3937 120.151 57.3076 121.928 58.979L120.558 60.4359ZM115.384 58.4306C113.465 58.4598 111.632 59.2351 110.274 60.5924L108.86 59.1779C110.586 57.4532 112.915 56.4679 115.354 56.4308L115.384 58.4306ZM110.274 60.5924C108.917 61.9496 108.141 63.7821 108.111 65.7016L106.111 65.6705C106.149 63.2313 107.135 60.9026 108.86 59.1779L110.274 60.5924ZM108.111 65.7016C108.081 67.6212 108.799 69.477 110.114 70.8758L108.657 72.2456C106.986 70.468 106.073 68.1097 106.111 65.6705L108.111 65.7016ZM110.093 72.2678L93.9182 88.4424L92.504 87.0281L108.678 70.8536L110.093 72.2678ZM93.9182 87.0281L131.641 124.751L130.226 126.165L92.504 88.4424L93.9182 87.0281ZM130.226 124.751L146.401 108.576L147.815 109.991L131.641 126.165L130.226 124.751ZM147.815 108.576C149.2 109.961 151.077 110.739 153.035 110.74V112.74C150.547 112.739 148.16 111.75 146.401 109.99L147.815 108.576ZM153.035 110.74C154.005 110.74 154.965 110.549 155.861 110.178L156.626 112.026C155.487 112.498 154.267 112.74 153.035 112.74V110.74ZM155.861 110.178C156.757 109.807 157.571 109.264 158.256 108.578L159.67 109.993C158.799 110.864 157.764 111.555 156.626 112.026L155.861 110.178ZM158.256 108.578C158.942 107.893 159.486 107.079 159.857 106.183L161.705 106.949C161.233 108.087 160.542 109.122 159.67 109.993L158.256 108.578ZM159.857 106.183C160.228 105.288 160.42 104.328 160.42 103.358L162.42 103.359C162.419 104.591 162.177 105.811 161.705 106.949L159.857 106.183ZM160.42 103.358C160.42 102.389 160.229 101.429 159.858 100.532L161.706 99.7674C162.177 100.906 162.42 102.126 162.42 103.359L160.42 103.358ZM159.858 100.532C159.487 99.6366 158.944 98.8227 158.258 98.137L159.673 96.7228C160.544 97.5943 161.235 98.6289 161.706 99.7674L159.858 100.532Z",
    fill: "#B0DED4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.816 56.75H54.4452C50.1313 56.75 45.9941 58.4637 42.9438 61.5141C39.8934 64.5644 38.1797 68.7016 38.1797 73.0155V190.374C38.1797 194.688 39.8934 198.825 42.9438 201.876C45.9941 204.926 50.1313 206.64 54.4452 206.64H146.656C150.97 206.64 155.107 204.926 158.157 201.876C161.208 198.825 162.921 194.688 162.921 190.374V102.855H125.699C123.44 102.855 121.224 101.731 119.582 100.089C117.94 98.4472 116.816 96.2308 116.816 93.9725V56.75Z",
    fill: "white",
    stroke: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.312 56.25H108.93V93.9725C108.93 98.419 110.696 102.684 113.84 105.828C116.984 108.972 121.249 110.738 125.695 110.738H163.418V102.356H125.695C121.504 102.356 117.312 98.1639 117.312 93.9725V56.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3592 102.891C96.3592 104.002 95.9176 105.068 95.1316 105.854C94.3455 106.64 93.2794 107.082 92.1678 107.082H58.6367C57.5251 107.082 56.459 106.64 55.6729 105.854C54.8869 105.068 54.4453 104.002 54.4453 102.891C54.4453 101.779 54.8869 100.713 55.6729 99.9268C56.459 99.1407 57.5251 98.6992 58.6367 98.6992H92.1678C93.2794 98.6992 94.3455 99.1407 95.1316 99.9268C95.9176 100.713 96.3592 101.779 96.3592 102.891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3592 166.898C96.3592 168.01 95.9176 169.076 95.1316 169.862C94.3455 170.648 93.2794 171.09 92.1678 171.09H58.6367C57.5251 171.09 56.459 170.648 55.6729 169.862C54.8869 169.076 54.4453 168.01 54.4453 166.898C54.4453 165.787 54.8869 164.721 55.6729 163.935C56.459 163.149 57.5251 162.707 58.6367 162.707H92.1678C93.2794 162.707 94.3455 163.149 95.1316 163.935C95.9176 164.721 96.3592 165.787 96.3592 166.898Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.656 123.234C146.656 124.346 146.214 125.412 145.428 126.198C144.642 126.984 143.576 127.426 142.464 127.426H58.6367C57.5251 127.426 56.459 126.984 55.6729 126.198C54.8869 125.412 54.4453 124.346 54.4453 123.234C54.4453 122.123 54.8869 121.057 55.6729 120.271C56.459 119.485 57.5251 119.043 58.6367 119.043H142.464C143.576 119.043 144.642 119.485 145.428 120.271C146.214 121.057 146.656 122.123 146.656 123.234Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.067 143.553C131.067 144.672 130.702 145.744 130.05 146.535C129.399 147.326 128.515 147.771 127.594 147.771H58.1297C57.2085 147.771 56.3249 147.326 55.6735 146.535C55.0222 145.744 54.6562 144.672 54.6562 143.553C54.6562 142.434 55.0222 141.362 55.6735 140.571C56.3249 139.78 57.2085 139.336 58.1297 139.336H127.594C128.515 139.336 129.399 139.78 130.05 140.571C130.702 141.362 131.067 142.434 131.067 143.553Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.514 237.531L194.32 241.02L202.461 250.806L206.655 247.318L198.514 237.531Z",
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.655 299.645C241.848 303.644 234.709 302.989 230.71 298.182L198.69 259.693C197.087 257.766 197.35 254.903 199.277 253.3L209.706 244.624C211.633 243.021 214.495 243.283 216.099 245.211L248.118 283.699C252.118 288.507 251.463 295.646 246.655 299.645Z",
    fill: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.141 278.214C234.66 278.615 233.945 278.549 233.545 278.068L210.668 250.569C210.268 250.088 210.334 249.374 210.815 248.973C211.296 248.573 212.011 248.638 212.411 249.12L235.288 276.618C235.688 277.099 235.623 277.814 235.141 278.214Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.333 284.345C239.852 284.745 239.138 284.68 238.737 284.199L236.504 281.515C236.104 281.033 236.17 280.319 236.651 279.918C237.132 279.518 237.847 279.584 238.247 280.065L240.48 282.749C240.88 283.23 240.815 283.945 240.333 284.345Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.681 191.751C220.681 225.164 193.594 252.251 160.18 252.251C126.767 252.251 99.6797 225.164 99.6797 191.751C99.6797 158.337 126.767 131.25 160.18 131.25C193.594 131.25 220.681 158.337 220.681 191.751ZM211.177 191.751C211.177 219.915 188.345 242.746 160.181 242.746C132.017 242.746 109.186 219.915 109.186 191.751C109.186 163.586 132.017 140.755 160.181 140.755C188.345 140.755 211.177 163.586 211.177 191.751Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.158 135.238C156.136 135.238 156.115 135.239 156.094 135.241C149.998 135.727 144.052 137.181 138.421 139.563C131.592 142.451 125.459 146.586 120.192 151.852C116.35 155.694 113.086 160.035 110.489 164.753C110.292 165.111 110.426 165.565 110.787 165.764L110.815 165.78C110.992 165.878 111.197 165.901 111.391 165.844C111.582 165.789 111.739 165.664 111.834 165.491C114.361 160.901 117.538 156.677 121.278 152.938C126.404 147.812 132.372 143.788 139.019 140.977C144.5 138.658 150.29 137.243 156.227 136.771C156.61 136.74 156.91 136.411 156.91 136.022V135.991C156.91 135.779 156.825 135.583 156.669 135.439C156.527 135.308 156.35 135.238 156.158 135.238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.488 171.199L108.461 171.185C108.355 171.13 108.236 171.102 108.117 171.102C108.025 171.102 107.935 171.118 107.85 171.151C107.65 171.227 107.492 171.384 107.415 171.584L107.383 171.669C107.303 171.877 107.229 172.069 107.168 172.226C105.379 176.798 104.329 181.085 103.762 186.124C103.738 186.343 103.812 186.56 103.964 186.72C104.119 186.881 104.334 186.964 104.56 186.95L104.597 186.947C104.958 186.923 105.249 186.642 105.29 186.279C105.842 181.382 106.862 177.22 108.597 172.785C108.66 172.623 108.741 172.409 108.829 172.177L108.841 172.146C108.982 171.776 108.828 171.375 108.488 171.199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.941 35.75H200.238C192.888 35.75 186.93 41.7748 186.93 49.2069V121.571C186.93 129.003 192.888 135.028 200.238 135.028H231.461C232.232 135.028 232.971 135.337 233.516 135.888L244.624 147.12C245.451 147.957 246.793 147.957 247.62 147.12L258.728 135.888C259.273 135.337 260.012 135.028 260.783 135.028H303.941C311.291 135.028 309.739 129.003 309.739 121.571V49.207C309.74 41.7748 311.291 35.75 303.941 35.75Z",
    fill: "url(#paint0_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.012 36.0273H200.569C193.256 36.0273 187.328 42.0251 187.328 49.4236V121.461C187.328 128.86 193.256 134.857 200.569 134.857H231.539C232.305 134.857 233.041 135.165 233.583 135.714L244.634 146.895C245.458 147.728 246.792 147.728 247.616 146.895L258.667 135.714C259.209 135.165 259.945 134.857 260.711 134.857H304.012C311.325 134.857 309.347 128.86 309.347 121.461V49.4236C309.347 42.0251 311.325 36.0273 304.012 36.0273Z",
    fill: "url(#paint1_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.075 36.3008H200.892C193.616 36.3008 187.719 42.2712 187.719 49.6362V121.347C187.719 128.712 193.616 134.683 200.892 134.683H231.609C232.372 134.683 233.103 134.989 233.643 135.535L244.637 146.666C245.456 147.495 246.784 147.495 247.603 146.666L258.598 135.535C259.138 134.989 259.869 134.683 260.632 134.683H304.075C311.351 134.683 308.947 128.712 308.947 121.347V49.6362C308.947 42.2714 311.351 36.3008 304.075 36.3008Z",
    fill: "url(#paint2_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.146 36.5781H201.222C193.984 36.5781 188.117 42.5215 188.117 49.8529V121.237C188.117 128.569 193.985 134.512 201.222 134.512H231.687C232.445 134.512 233.173 134.818 233.71 135.361L244.648 146.441C245.463 147.266 246.784 147.266 247.599 146.441L258.537 135.361C259.074 134.817 259.802 134.512 260.56 134.512H304.146C311.384 134.512 308.555 128.569 308.555 121.237V49.8529C308.555 42.5215 311.384 36.5781 304.146 36.5781Z",
    fill: "url(#paint3_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.209 36.8555H201.545C194.345 36.8555 188.508 42.7717 188.508 50.0695V121.127C188.508 128.425 194.345 134.341 201.545 134.341H231.757C232.512 134.341 233.236 134.645 233.769 135.187L244.651 146.216C245.462 147.037 246.776 147.037 247.586 146.216L258.468 135.187C259.002 134.645 259.726 134.341 260.481 134.341H304.209C311.41 134.341 308.155 128.425 308.155 121.127V50.0694C308.155 42.7716 311.41 36.8555 304.209 36.8555Z",
    fill: "url(#paint4_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.28 37.1289H201.876C194.713 37.1289 188.906 43.0179 188.906 50.2823V121.014C188.906 128.278 194.713 134.167 201.876 134.167H231.834C232.585 134.167 233.306 134.47 233.837 135.008L244.662 145.987C245.468 146.805 246.776 146.805 247.582 145.987L258.407 135.008C258.938 134.47 259.658 134.167 260.409 134.167H304.28C311.443 134.167 307.763 128.278 307.763 121.014V50.2823C307.763 43.0179 311.443 37.1289 304.28 37.1289Z",
    fill: "url(#paint5_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.351 37.4062H202.206C195.081 37.4062 189.305 43.2682 189.305 50.4991V120.904C189.305 128.135 195.081 133.997 202.206 133.997H231.912C232.659 133.997 233.376 134.298 233.904 134.834L244.673 145.762C245.475 146.576 246.775 146.576 247.578 145.762L258.346 134.834C258.874 134.298 259.591 133.997 260.338 133.997H304.351C311.477 133.997 307.371 128.135 307.371 120.904V50.4991C307.371 43.2682 311.477 37.4062 304.351 37.4062Z",
    fill: "url(#paint6_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.415 37.6836H202.529C195.441 37.6836 189.695 43.5182 189.695 50.7156V120.794C189.695 127.991 195.441 133.826 202.529 133.826H231.982C232.725 133.826 233.438 134.126 233.964 134.659L244.676 145.537C245.474 146.347 246.767 146.347 247.565 145.537L258.277 134.659C258.803 134.126 259.516 133.826 260.259 133.826H304.415C311.503 133.826 306.971 127.991 306.971 120.794V50.7156C306.971 43.5182 311.503 37.6836 304.415 37.6836Z",
    fill: "url(#paint7_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.486 37.9609H202.86C195.809 37.9609 190.094 43.7684 190.094 50.9321V120.684C190.094 127.848 195.809 133.655 202.86 133.655H232.06C232.799 133.655 233.508 133.954 234.031 134.485L244.687 145.311C245.48 146.118 246.767 146.118 247.561 145.311L258.216 134.485C258.739 133.954 259.448 133.655 260.187 133.655H304.486C311.536 133.655 306.579 127.848 306.579 120.684V50.932C306.579 43.7684 311.536 37.9609 304.486 37.9609Z",
    fill: "url(#paint8_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.549 38.2344H203.183C196.17 38.2344 190.484 44.0146 190.484 51.1449V120.57C190.484 127.701 196.17 133.481 203.183 133.481H232.13C232.865 133.481 233.571 133.778 234.091 134.307L244.689 145.082C245.479 145.885 246.759 145.885 247.548 145.082L258.147 134.307C258.667 133.778 259.373 133.481 260.108 133.481H304.549C311.562 133.481 306.179 127.701 306.179 120.57V51.1448C306.179 44.0146 311.562 38.2344 304.549 38.2344Z",
    fill: "url(#paint9_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.62 38.5117H203.513C196.538 38.5117 190.883 44.2648 190.883 51.3615V120.461C190.883 127.557 196.538 133.31 203.513 133.31H232.208C232.939 133.31 233.641 133.606 234.158 134.132L244.7 144.857C245.485 145.656 246.759 145.656 247.544 144.857L258.086 134.132C258.603 133.606 259.305 133.31 260.036 133.31H304.619C311.595 133.31 305.787 127.557 305.787 120.461V51.3615C305.787 44.2648 311.595 38.5117 304.62 38.5117Z",
    fill: "url(#paint10_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.69 38.7891H203.844C196.906 38.7891 191.281 44.5149 191.281 51.5782V120.351C191.281 127.414 196.906 133.14 203.844 133.14H232.286C233.013 133.14 233.711 133.434 234.225 133.958L244.711 144.632C245.492 145.427 246.758 145.427 247.54 144.632L258.025 133.958C258.54 133.434 259.237 133.14 259.965 133.14H304.69C311.629 133.14 305.395 127.414 305.395 120.351V51.5782C305.395 44.5149 311.629 38.7891 304.69 38.7891Z",
    fill: "url(#paint11_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.754 39.0625H204.167C197.266 39.0625 191.672 44.7612 191.672 51.7909V120.237C191.672 127.267 197.266 132.965 204.167 132.965H232.356C233.079 132.965 233.773 133.258 234.285 133.779L244.714 144.403C245.491 145.195 246.75 145.195 247.527 144.403L257.956 133.779C258.468 133.258 259.162 132.965 259.886 132.965H304.754C311.654 132.965 304.995 127.267 304.995 120.237V51.7909C304.995 44.7612 311.654 39.0625 304.754 39.0625Z",
    fill: "url(#paint12_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.824 39.3398H204.498C197.634 39.3398 192.07 45.0114 192.07 52.0074V120.127C192.07 127.123 197.634 132.795 204.498 132.795H232.434C233.153 132.795 233.843 133.086 234.352 133.605L244.725 144.178C245.497 144.966 246.75 144.966 247.523 144.178L257.895 133.605C258.404 133.086 259.094 132.795 259.814 132.795H304.825C311.688 132.795 304.603 127.123 304.603 120.127V52.0074C304.603 45.0113 311.688 39.3398 304.824 39.3398Z",
    fill: "url(#paint13_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.888 39.6172H204.82C197.995 39.6172 192.461 45.2615 192.461 52.2241V120.017C192.461 126.98 197.994 132.624 204.82 132.624H232.504C233.219 132.624 233.906 132.914 234.412 133.431L244.728 143.953C245.496 144.737 246.742 144.737 247.51 143.953L257.826 133.431C258.332 132.914 259.019 132.624 259.735 132.624H304.888C311.713 132.624 304.203 126.98 304.203 120.017V52.2241C304.203 45.2615 311.714 39.6172 304.888 39.6172Z",
    fill: "url(#paint14_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.959 39.8906H205.151C198.363 39.8906 192.859 45.5078 192.859 52.4368V119.904C192.859 126.833 198.363 132.45 205.151 132.45H232.581C233.293 132.45 233.976 132.738 234.479 133.252L244.738 143.724C245.503 144.504 246.742 144.504 247.506 143.724L257.765 133.252C258.269 132.738 258.951 132.45 259.663 132.45H304.959C311.747 132.45 303.811 126.833 303.811 119.904V52.4368C303.811 45.5078 311.747 39.8906 304.959 39.8906Z",
    fill: "url(#paint15_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.029 40.168H205.482C198.731 40.168 193.258 45.7579 193.258 52.6535V119.794C193.258 126.689 198.731 132.279 205.482 132.279H232.659C233.367 132.279 234.046 132.566 234.547 133.078L244.749 143.499C245.509 144.275 246.742 144.275 247.502 143.499L257.704 133.078C258.205 132.567 258.884 132.279 259.592 132.279H305.03C311.781 132.279 303.419 126.689 303.419 119.794V52.6535C303.419 45.7579 311.781 40.168 305.029 40.168Z",
    fill: "url(#paint16_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.093 40.4453H205.805C199.091 40.4453 193.648 46.0081 193.648 52.8701V119.684C193.648 126.546 199.091 132.109 205.805 132.109H232.729C233.433 132.109 234.108 132.394 234.606 132.903L244.752 143.273C245.508 144.046 246.734 144.046 247.489 143.273L257.636 132.903C258.133 132.394 258.808 132.109 259.512 132.109H305.093C311.806 132.109 303.019 126.546 303.019 119.684V52.87C303.019 46.0081 311.806 40.4453 305.093 40.4453Z",
    fill: "url(#paint17_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.164 40.7188H206.135C199.459 40.7188 194.047 46.2543 194.047 53.0829V119.57C194.047 126.399 199.459 131.934 206.135 131.934H232.807C233.507 131.934 234.178 132.219 234.673 132.725L244.763 143.045C245.515 143.813 246.733 143.813 247.485 143.045L257.574 132.725C258.069 132.219 258.741 131.934 259.441 131.934H305.163C311.84 131.934 302.626 126.399 302.626 119.57V53.0829C302.627 46.2544 311.84 40.7188 305.164 40.7188Z",
    fill: "url(#paint18_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.226 40.9961H206.457C199.818 40.9961 194.438 46.5045 194.438 53.2994V119.46C194.438 126.255 199.818 131.764 206.457 131.764H232.876C233.572 131.764 234.24 132.047 234.732 132.55L244.766 142.82C245.513 143.584 246.725 143.584 247.473 142.82L257.506 132.55C257.998 132.047 258.664 131.764 259.36 131.764H305.226C311.864 131.764 302.226 126.255 302.226 119.46V53.2994C302.226 46.5044 311.864 40.9961 305.226 40.9961Z",
    fill: "url(#paint19_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.298 41.2734H206.789C200.188 41.2734 194.836 46.7547 194.836 53.5161V119.35C194.836 126.112 200.187 131.593 206.789 131.593H232.955C233.647 131.593 234.311 131.875 234.8 132.376L244.777 142.595C245.52 143.356 246.725 143.356 247.468 142.595L257.445 132.376C257.934 131.875 258.598 131.593 259.29 131.593H305.298C311.899 131.593 301.835 126.112 301.835 119.35V53.5161C301.834 46.7546 311.899 41.2734 305.298 41.2734Z",
    fill: "url(#paint20_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.369 41.5469H207.119C200.556 41.5469 195.234 47.0009 195.234 53.7288V119.237C195.234 125.964 200.555 131.419 207.119 131.419H233.033C233.721 131.419 234.381 131.699 234.868 132.198L244.788 142.365C245.527 143.123 246.725 143.123 247.464 142.365L257.384 132.198C257.87 131.699 258.53 131.419 259.219 131.419H305.369C311.933 131.419 301.442 125.964 301.442 119.237V53.7287C301.442 47.0009 311.933 41.5469 305.369 41.5469Z",
    fill: "url(#paint21_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.432 41.8242H207.442C200.916 41.8242 195.625 47.2511 195.625 53.9455V119.127C195.625 125.821 200.916 131.248 207.442 131.248H233.103C233.787 131.248 234.443 131.527 234.927 132.023L244.791 142.14C245.525 142.894 246.717 142.894 247.451 142.14L257.315 132.023C257.798 131.527 258.455 131.248 259.139 131.248H305.432C311.958 131.248 301.042 125.821 301.042 119.127V53.9455C301.042 47.251 311.958 41.8242 305.432 41.8242Z",
    fill: "url(#paint22_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.503 42.1016H207.773C201.284 42.1016 196.023 47.5012 196.023 54.1621V119.017C196.023 125.678 201.284 131.077 207.773 131.077H233.181C233.861 131.077 234.513 131.355 234.995 131.849L244.801 141.915C245.532 142.665 246.716 142.665 247.447 141.915L257.253 131.849C257.735 131.355 258.387 131.077 259.068 131.077H305.503C311.992 131.077 300.65 125.678 300.65 119.017V54.1621C300.65 47.5012 311.992 42.1016 305.503 42.1016Z",
    fill: "url(#paint23_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.566 42.3789H208.096C201.644 42.3789 196.414 47.7514 196.414 54.3788V118.907C196.414 125.534 201.644 130.907 208.096 130.907H233.251C233.927 130.907 234.576 131.183 235.054 131.674L244.804 141.69C245.531 142.436 246.708 142.436 247.434 141.69L257.185 131.674C257.663 131.183 258.312 130.907 258.988 130.907H305.566C312.017 130.907 300.25 125.534 300.25 118.907V54.3788C300.25 47.7514 312.017 42.3789 305.566 42.3789Z",
    fill: "url(#paint24_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.637 42.6523H208.426C202.012 42.6523 196.812 47.9976 196.812 54.5914V118.793C196.812 125.387 202.012 130.732 208.426 130.732H233.329C234.002 130.732 234.647 131.007 235.122 131.496L244.816 141.461C245.538 142.203 246.708 142.203 247.43 141.461L257.124 131.496C257.599 131.007 258.244 130.732 258.917 130.732H305.637C312.051 130.732 299.859 125.387 299.859 118.793V54.5914C299.859 47.9976 312.051 42.6523 305.637 42.6523Z",
    fill: "url(#paint25_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.7 42.9297H208.749C202.372 42.9297 197.203 48.2478 197.203 54.808V118.684C197.203 125.244 202.373 130.562 208.749 130.562H233.398C234.067 130.562 234.708 130.835 235.181 131.322L244.818 141.236C245.536 141.974 246.7 141.974 247.418 141.236L257.055 131.322C257.528 130.835 258.169 130.562 258.837 130.562H305.7C312.077 130.562 299.458 125.244 299.458 118.684V54.808C299.458 48.2477 312.076 42.9297 305.7 42.9297Z",
    fill: "url(#paint26_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.771 43.207H209.08C202.741 43.207 197.602 48.4979 197.602 55.0247V118.574C197.602 125.1 202.741 130.391 209.08 130.391H233.476C234.141 130.391 234.778 130.663 235.248 131.147L244.829 141.011C245.542 141.745 246.7 141.745 247.413 141.011L256.994 131.147C257.464 130.663 258.101 130.391 258.766 130.391H305.771C312.11 130.391 299.066 125.1 299.066 118.574V55.0247C299.066 48.4979 312.11 43.207 305.771 43.207Z",
    fill: "url(#paint27_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.842 43.4805H209.411C203.109 43.4805 198 48.7442 198 55.2374V118.46C198 124.953 203.109 130.217 209.411 130.217H233.554C234.215 130.217 234.849 130.487 235.316 130.969L244.84 140.782C245.549 141.513 246.699 141.513 247.409 140.782L256.933 130.969C257.4 130.487 258.034 130.217 258.694 130.217H305.842C312.144 130.217 298.674 124.953 298.674 118.46V55.2374C298.674 48.7442 312.144 43.4805 305.842 43.4805Z",
    fill: "url(#paint28_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.905 43.7578H209.733C203.469 43.7578 198.391 48.9945 198.391 55.4541V118.35C198.391 124.81 203.469 130.046 209.733 130.046H233.624C234.281 130.046 234.911 130.315 235.375 130.794L244.843 140.557C245.548 141.284 246.691 141.284 247.396 140.557L256.864 130.794C257.328 130.315 257.958 130.046 258.615 130.046H305.905C312.169 130.046 298.274 124.81 298.274 118.35V55.4541C298.274 48.9943 312.169 43.7578 305.905 43.7578Z",
    fill: "url(#paint29_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.976 44.0352H210.064C203.837 44.0352 198.789 49.2446 198.789 55.6707V118.24C198.789 124.666 203.837 129.876 210.064 129.876H233.702C234.355 129.876 234.981 130.143 235.443 130.62L244.853 140.332C245.554 141.055 246.691 141.055 247.392 140.332L256.803 130.62C257.264 130.143 257.891 129.876 258.544 129.876H305.976C312.203 129.876 297.882 124.666 297.882 118.24V55.6707C297.882 49.2446 312.203 44.0352 305.976 44.0352Z",
    fill: "url(#paint30_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.039 44.3086H210.387C204.197 44.3086 199.18 49.4908 199.18 55.8835V118.127C199.18 124.519 204.197 129.701 210.387 129.701H233.772C234.421 129.701 235.043 129.968 235.502 130.442L244.856 140.103C245.553 140.822 246.683 140.822 247.38 140.103L256.734 130.442C257.193 129.968 257.815 129.701 258.464 129.701H306.039C312.229 129.701 297.482 124.519 297.482 118.127V55.8835C297.482 49.4909 312.229 44.3086 306.039 44.3086Z",
    fill: "url(#paint31_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.11 44.5859H210.718C204.565 44.5859 199.578 49.741 199.578 56.1V118.017C199.578 124.376 204.565 129.531 210.718 129.531H233.85C234.495 129.531 235.113 129.796 235.57 130.267L244.867 139.877C245.56 140.593 246.683 140.593 247.375 139.877L256.673 130.267C257.129 129.795 257.748 129.531 258.393 129.531H306.11C312.262 129.531 297.09 124.376 297.09 118.017V56.1C297.09 49.741 312.262 44.5859 306.11 44.5859Z",
    fill: "url(#paint32_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.181 44.8633H211.048C204.933 44.8633 199.977 49.9912 199.977 56.3167V117.907C199.977 124.232 204.933 129.36 211.048 129.36H233.928C234.569 129.36 235.184 129.624 235.637 130.093L244.878 139.652C245.566 140.364 246.682 140.364 247.371 139.652L256.612 130.093C257.065 129.624 257.68 129.36 258.321 129.36H306.181C312.295 129.36 296.698 124.232 296.698 117.907V56.3167C296.698 49.9912 312.295 44.8633 306.181 44.8633Z",
    fill: "url(#paint33_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.244 45.1367H211.371C205.294 45.1367 200.367 50.2374 200.367 56.5294V117.793C200.367 124.085 205.294 129.186 211.371 129.186H233.998C234.635 129.186 235.246 129.448 235.697 129.914L244.881 139.423C245.565 140.132 246.674 140.132 247.358 139.423L256.543 129.914C256.993 129.448 257.605 129.186 258.242 129.186H306.244C312.321 129.186 296.298 124.085 296.298 117.793V56.5293C296.298 50.2374 312.321 45.1367 306.244 45.1367Z",
    fill: "url(#paint34_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.315 45.4141H211.702C205.662 45.4141 200.766 50.4876 200.766 56.7461V117.683C200.766 123.942 205.662 129.015 211.702 129.015H234.075C234.709 129.015 235.316 129.276 235.764 129.74L244.892 139.198C245.572 139.903 246.674 139.903 247.354 139.198L256.482 129.74C256.93 129.276 257.537 129.015 258.17 129.015H306.315C312.355 129.015 295.906 123.942 295.906 117.683V56.746C295.906 50.4875 312.355 45.4141 306.315 45.4141Z",
    fill: "url(#paint35_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.378 45.6914H212.025C206.022 45.6914 201.156 50.7377 201.156 56.9627V117.573C201.156 123.798 206.022 128.845 212.025 128.845H234.145C234.775 128.845 235.378 129.104 235.823 129.565L244.895 138.973C245.57 139.674 246.666 139.674 247.342 138.973L256.413 129.565C256.858 129.104 257.462 128.845 258.091 128.845H306.378C312.38 128.845 295.506 123.798 295.506 117.573V56.9627C295.506 50.7377 312.38 45.6914 306.378 45.6914Z",
    fill: "url(#paint36_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.449 45.9648H212.355C206.39 45.9648 201.555 50.984 201.555 57.1755V117.46C201.555 123.651 206.39 128.67 212.355 128.67H234.223C234.849 128.67 235.449 128.928 235.891 129.387L244.906 138.744C245.577 139.441 246.666 139.441 247.337 138.744L256.352 129.387C256.794 128.928 257.394 128.67 258.02 128.67H306.449C312.414 128.67 295.114 123.651 295.114 117.46V57.1755C295.114 50.984 312.414 45.9648 306.449 45.9648Z",
    fill: "url(#paint37_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.52 46.2422H212.686C206.758 46.2422 201.953 51.2341 201.953 57.392V117.35C201.953 123.508 206.758 128.5 212.686 128.5H234.301C234.923 128.5 235.519 128.756 235.958 129.213L244.916 138.519C245.584 139.212 246.666 139.212 247.333 138.519L256.291 129.213C256.73 128.756 257.327 128.5 257.948 128.5H306.52C312.447 128.5 294.722 123.508 294.722 117.35V57.3919C294.722 51.2342 312.447 46.2422 306.52 46.2422Z",
    fill: "url(#paint38_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.583 46.5195H213.009C207.119 46.5195 202.344 51.4843 202.344 57.6086V117.24C202.344 123.364 207.119 128.329 213.009 128.329H234.371C234.989 128.329 235.581 128.584 236.018 129.038L244.919 138.294C245.582 138.983 246.657 138.983 247.321 138.294L256.222 129.038C256.659 128.584 257.251 128.329 257.869 128.329H306.583C312.473 128.329 294.321 123.364 294.321 117.24V57.6086C294.322 51.4843 312.473 46.5195 306.583 46.5195Z",
    fill: "url(#paint39_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.654 46.7969H213.339C207.487 46.7969 202.742 51.7345 202.742 57.8253V117.13C202.742 123.221 207.487 128.158 213.339 128.158H234.449C235.063 128.158 235.651 128.412 236.085 128.864L244.93 138.069C245.589 138.754 246.657 138.754 247.316 138.069L256.161 128.864C256.595 128.412 257.184 128.158 257.797 128.158H306.654C312.507 128.158 293.93 123.221 293.93 117.13V57.8253C293.93 51.7345 312.507 46.7969 306.654 46.7969Z",
    fill: "url(#paint40_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.717 47.0703H213.662C207.847 47.0703 203.133 51.9807 203.133 58.038V117.016C203.133 123.073 207.847 127.984 213.662 127.984H234.519C235.129 127.984 235.713 128.236 236.145 128.685L244.933 137.84C245.588 138.522 246.649 138.522 247.304 137.84L256.092 128.685C256.523 128.236 257.108 127.984 257.718 127.984H306.717C312.532 127.984 293.53 123.073 293.53 117.016V58.0381C293.529 51.9808 312.532 47.0703 306.717 47.0703Z",
    fill: "url(#paint41_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.788 47.3477H213.993C208.215 47.3477 203.531 52.2309 203.531 58.2547V116.906C203.531 122.93 208.215 127.813 213.993 127.813H234.597C235.203 127.813 235.784 128.064 236.212 128.511L244.944 137.614C245.594 138.293 246.649 138.293 247.299 137.614L256.031 128.511C256.459 128.064 257.04 127.813 257.646 127.813H306.788C312.566 127.813 293.137 122.93 293.137 116.906V58.2547C293.137 52.2308 312.566 47.3477 306.788 47.3477Z",
    fill: "url(#paint42_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.859 47.625H214.324C208.583 47.625 203.93 52.481 203.93 58.4712V116.797C203.93 122.787 208.583 127.643 214.324 127.643H234.675C235.276 127.643 235.854 127.892 236.279 128.336L244.955 137.389C245.601 138.064 246.649 138.064 247.295 137.389L255.97 128.336C256.396 127.892 256.973 127.643 257.575 127.643H306.859C312.599 127.643 292.745 122.787 292.745 116.797V58.4712C292.745 52.481 312.599 47.625 306.859 47.625Z",
    fill: "url(#paint43_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.922 47.8984H214.646C208.943 47.8984 204.32 52.7273 204.32 58.684V116.683C204.32 122.64 208.943 127.468 214.646 127.468H234.745C235.343 127.468 235.916 127.717 236.339 128.158L244.958 137.16C245.6 137.831 246.64 137.831 247.283 137.16L255.901 128.158C256.324 127.717 256.898 127.468 257.496 127.468H306.922C312.625 127.468 292.345 122.64 292.345 116.683V58.684C292.345 52.7273 312.625 47.8984 306.922 47.8984Z",
    fill: "url(#paint44_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.993 48.1758H214.977C209.311 48.1758 204.719 52.9774 204.719 58.9006V116.573C204.719 122.496 209.312 127.298 214.977 127.298H234.822C235.416 127.298 235.986 127.544 236.406 127.984L244.968 136.935C245.606 137.602 246.64 137.602 247.278 136.935L255.84 127.984C256.26 127.545 256.83 127.298 257.424 127.298H306.993C312.658 127.298 291.953 122.496 291.953 116.573V58.9006C291.953 52.9774 312.658 48.1758 306.993 48.1758Z",
    fill: "url(#paint45_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.056 48.4531H215.3C209.672 48.4531 205.109 53.2276 205.109 59.1173V116.463C205.109 122.353 209.672 127.127 215.3 127.127H234.892C235.483 127.127 236.048 127.373 236.466 127.809L244.971 136.71C245.605 137.373 246.632 137.373 247.266 136.71L255.771 127.809C256.188 127.373 256.754 127.127 257.345 127.127H307.056C312.684 127.127 291.553 122.353 291.553 116.463V59.1173C291.553 53.2276 312.684 48.4531 307.056 48.4531Z",
    fill: "url(#paint46_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.127 48.7266H215.63C210.04 48.7266 205.508 53.4739 205.508 59.33V116.349C205.508 122.206 210.04 126.953 215.63 126.953H234.97C235.556 126.953 236.119 127.197 236.533 127.631L244.982 136.481C245.611 137.14 246.632 137.14 247.261 136.481L255.71 127.631C256.125 127.197 256.687 126.953 257.273 126.953H307.127C312.718 126.953 291.161 122.205 291.161 116.349V59.33C291.161 53.4739 312.718 48.7266 307.127 48.7266Z",
    fill: "url(#paint47_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.198 49.0039H215.961C210.408 49.0039 205.906 53.724 205.906 59.5467V116.24C205.906 122.062 210.408 126.782 215.961 126.782H235.048C235.63 126.782 236.189 127.025 236.6 127.457L244.993 136.256C245.618 136.912 246.632 136.912 247.257 136.256L255.649 127.457C256.061 127.025 256.619 126.782 257.202 126.782H307.198C312.751 126.782 290.769 122.062 290.769 116.24V59.5467C290.769 53.724 312.751 49.0039 307.198 49.0039Z",
    fill: "url(#paint48_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.261 49.2812H216.284C210.768 49.2812 206.297 53.9745 206.297 59.7635V116.13C206.297 121.919 210.768 126.612 216.284 126.612H235.118C235.697 126.612 236.251 126.853 236.66 127.282L244.996 136.031C245.617 136.683 246.624 136.683 247.245 136.031L255.58 127.282C255.989 126.853 256.544 126.612 257.122 126.612H307.261C312.777 126.612 290.369 121.919 290.369 116.13V59.7635C290.369 53.9745 312.777 49.2812 307.261 49.2812Z",
    fill: "url(#paint49_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.332 49.5547H216.615C211.136 49.5547 206.695 54.2204 206.695 59.9759V116.016C206.695 121.771 211.136 126.437 216.615 126.437H235.196C235.77 126.437 236.321 126.677 236.727 127.104L245.007 135.802C245.623 136.45 246.623 136.45 247.24 135.802L255.519 127.104C255.926 126.677 256.476 126.437 257.051 126.437H307.332C312.81 126.437 289.977 121.771 289.977 116.016V59.9759C289.977 54.2204 312.81 49.5547 307.332 49.5547Z",
    fill: "url(#paint50_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.395 49.832H216.938C211.497 49.832 207.086 54.4706 207.086 60.1926V115.906C207.086 121.628 211.497 126.267 216.938 126.267H235.266C235.837 126.267 236.384 126.505 236.787 126.929L245.01 135.577C245.622 136.221 246.615 136.221 247.228 135.577L255.451 126.929C255.854 126.505 256.401 126.267 256.972 126.267H307.395C312.836 126.267 289.577 121.628 289.577 115.906V60.1925C289.577 54.4705 312.836 49.832 307.395 49.832Z",
    fill: "url(#paint51_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.466 50.1094H217.268C211.865 50.1094 207.484 54.7208 207.484 60.4093V115.796C207.484 121.485 211.865 126.096 217.268 126.096H235.344C235.91 126.096 236.454 126.333 236.854 126.755L245.02 135.352C245.629 135.992 246.615 135.992 247.223 135.352L255.389 126.755C255.79 126.333 256.333 126.096 256.9 126.096H307.466C312.869 126.096 289.185 121.485 289.185 115.796V60.4093C289.185 54.7208 312.869 50.1094 307.466 50.1094Z",
    fill: "url(#paint52_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.537 50.3828H217.599C212.233 50.3828 207.883 54.9671 207.883 60.622V115.682C207.883 121.337 212.233 125.922 217.599 125.922H235.422C235.984 125.922 236.524 126.157 236.922 126.576L245.031 135.123C245.635 135.759 246.615 135.759 247.219 135.123L255.328 126.576C255.726 126.157 256.266 125.922 256.829 125.922H307.537C312.903 125.922 288.793 121.337 288.793 115.682V60.622C288.793 54.9671 312.903 50.3828 307.537 50.3828Z",
    fill: "url(#paint53_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.6 50.6602H217.922C212.593 50.6602 208.273 55.2171 208.273 60.8386V115.573C208.273 121.194 212.593 125.751 217.922 125.751H235.492C236.05 125.751 236.586 125.985 236.981 126.402L245.034 134.897C245.634 135.53 246.607 135.53 247.207 134.897L255.26 126.402C255.655 125.985 256.19 125.751 256.749 125.751H307.6C312.929 125.751 288.393 121.194 288.393 115.573V60.8386C288.393 55.2171 312.929 50.6602 307.6 50.6602Z",
    fill: "url(#paint54_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.671 50.9375H218.252C212.961 50.9375 208.672 55.4674 208.672 61.0553V115.463C208.672 121.051 212.961 125.581 218.252 125.581H235.569C236.124 125.581 236.656 125.813 237.049 126.228L245.045 134.672C245.641 135.301 246.606 135.301 247.202 134.672L255.199 126.228C255.591 125.813 256.123 125.581 256.678 125.581H307.671C312.962 125.581 288.001 121.051 288.001 115.463V61.0551C288.001 55.4674 312.962 50.9375 307.671 50.9375Z",
    fill: "url(#paint55_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.735 51.2148H218.576C213.322 51.2148 209.062 55.7175 209.062 61.2718V115.353C209.062 120.907 213.322 125.41 218.576 125.41H235.64C236.191 125.41 236.72 125.641 237.109 126.053L245.049 134.447C245.64 135.073 246.599 135.073 247.191 134.447L255.13 126.053C255.52 125.641 256.047 125.41 256.598 125.41H307.735C312.989 125.41 287.602 120.907 287.602 115.353V61.2718C287.602 55.7176 312.989 51.2148 307.735 51.2148Z",
    fill: "url(#paint56_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.805 51.4883H218.906C213.689 51.4883 209.461 55.9638 209.461 61.4846V115.239C209.461 120.76 213.69 125.236 218.906 125.236H235.717C236.264 125.236 236.789 125.465 237.175 125.875L245.059 134.218C245.646 134.84 246.598 134.84 247.185 134.218L255.068 125.875C255.455 125.465 255.98 125.236 256.527 125.236H307.805C313.021 125.236 287.209 120.76 287.209 115.239V61.4846C287.209 55.9638 313.021 51.4883 307.805 51.4883Z",
    fill: "url(#paint57_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.876 51.7656H219.236C214.058 51.7656 209.859 56.214 209.859 61.7012V115.129C209.859 120.616 214.058 125.065 219.236 125.065H235.795C236.338 125.065 236.859 125.293 237.243 125.7L245.069 133.993C245.652 134.611 246.598 134.611 247.181 133.993L255.007 125.7C255.391 125.293 255.912 125.065 256.455 125.065H307.876C313.055 125.065 286.817 120.616 286.817 115.129V61.7012C286.816 56.2139 313.055 51.7656 307.876 51.7656Z",
    fill: "url(#paint58_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.939 52.043H219.559C214.418 52.043 210.25 56.4641 210.25 61.9179V115.019C210.25 120.473 214.418 124.894 219.559 124.894H235.865C236.404 124.894 236.921 125.122 237.302 125.526L245.072 133.768C245.651 134.382 246.59 134.382 247.168 133.768L254.939 125.526C255.32 125.122 255.837 124.894 256.376 124.894H307.939C313.081 124.894 286.417 120.473 286.417 115.019V61.9179C286.417 56.4641 313.081 52.043 307.939 52.043Z",
    fill: "url(#paint59_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.01 52.3164H219.89C214.786 52.3164 210.648 56.7104 210.648 62.1306V114.906C210.648 120.326 214.786 124.72 219.89 124.72H235.943C236.478 124.72 236.991 124.946 237.37 125.347L245.083 133.539C245.658 134.149 246.589 134.149 247.164 133.539L254.878 125.347C255.256 124.946 255.769 124.72 256.305 124.72H308.01C313.114 124.72 286.024 120.326 286.024 114.906V62.1304C286.024 56.7104 313.114 52.3164 308.01 52.3164Z",
    fill: "url(#paint60_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.073 52.5938H220.213C215.146 52.5938 211.039 56.9603 211.039 62.347V114.796C211.039 120.183 215.146 124.549 220.213 124.549H236.013C236.544 124.549 237.054 124.774 237.429 125.173L245.086 133.314C245.657 133.92 246.581 133.92 247.152 133.314L254.809 125.173C255.184 124.774 255.694 124.549 256.225 124.549H308.073C313.14 124.549 285.625 120.183 285.625 114.796V62.347C285.625 56.9603 313.14 52.5938 308.073 52.5938Z",
    fill: "url(#paint61_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.144 52.8711H220.542C215.513 52.8711 211.438 57.2107 211.438 62.5638V114.686C211.438 120.039 215.513 124.379 220.542 124.379H236.09C236.618 124.379 237.123 124.602 237.496 124.999L245.096 133.089C245.662 133.691 246.58 133.691 247.146 133.089L254.746 124.999C255.119 124.602 255.626 124.379 256.153 124.379H308.144C313.173 124.379 285.231 120.039 285.231 114.686V62.5638C285.231 57.2107 313.173 52.8711 308.144 52.8711Z",
    fill: "url(#paint62_linear_5114_4257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.215 53.1445H220.874C215.882 53.1445 211.836 57.4569 211.836 62.7765V114.572C211.836 119.892 215.883 124.204 220.874 124.204H236.168C236.692 124.204 237.194 124.426 237.564 124.82L245.108 132.859C245.67 133.458 246.581 133.458 247.143 132.859L254.687 124.82C255.057 124.426 255.559 124.204 256.082 124.204H308.215C313.207 124.204 284.84 119.892 284.84 114.572V62.7765C284.84 57.457 313.207 53.1445 308.215 53.1445Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.484 31.7383H196.179C188.365 31.7383 182.031 38.0725 182.031 45.8861V121.965C182.031 129.779 188.365 136.113 196.179 136.113H230.533C231.352 136.113 232.138 136.439 232.717 137.018L244.526 148.826C245.406 149.706 246.832 149.706 247.711 148.826L259.52 137.018C260.099 136.439 260.885 136.113 261.704 136.113H300.484C308.297 136.113 314.631 129.779 314.631 121.965V45.8861C314.631 38.0724 308.297 31.7383 300.484 31.7383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.696 106.941C243.225 106.941 241.289 108.896 241.289 111.39C241.289 113.861 243.225 115.797 245.696 115.797C248.191 115.797 250.145 113.861 250.145 111.39C250.145 108.896 248.191 106.941 245.696 106.941Z",
    fill: "#ABDCC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.106 53.8633C243.192 53.8633 239.584 54.816 236.671 56.6183C233.766 58.4153 231.613 61.015 230.443 64.1361C229.777 65.7818 229.492 67.1208 229.492 68.6118C229.492 70.5914 230.643 71.7732 232.57 71.7732C234.315 71.7732 235.208 70.9363 235.756 68.7882L235.762 68.7647C236.92 63.2108 241.084 59.8952 246.899 59.8952C253.278 59.8952 257.734 63.8895 257.734 69.6086C257.734 73.7389 255.841 76.5313 250.755 79.9084C247.676 81.9098 245.632 83.7801 244.324 85.7946C242.96 87.8934 242.325 90.2328 242.325 93.157V95.1091C242.325 97.4432 243.616 98.8933 245.694 98.8933C247.756 98.8933 248.939 97.4837 248.939 95.026V93.9047C248.939 89.4346 250.384 87.2835 255.666 83.8971C258.694 81.9516 260.879 79.9013 262.344 77.6289C263.915 75.1924 264.679 72.4875 264.679 69.3597C264.679 60.3804 257.289 53.8633 247.106 53.8633Z",
    fill: "#ABDCC4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5114_4257",
    x1: 248.403,
    y1: 44.5406,
    x2: 248.403,
    y2: 140.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7563,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5114_4257",
    x1: 248.46,
    y1: 44.7783,
    x2: 248.46,
    y2: 139.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7563,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8C8C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5114_4257",
    x1: 248.523,
    y1: 45.0121,
    x2: 248.523,
    y2: 139.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7563,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5114_4257",
    x1: 248.608,
    y1: 45.2498,
    x2: 248.608,
    y2: 139.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7563,
    stopColor: "#C7C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C3C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5114_4257",
    x1: 248.698,
    y1: 45.4874,
    x2: 248.698,
    y2: 139.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7563,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5114_4257",
    x1: 248.807,
    y1: 45.7212,
    x2: 248.807,
    y2: 139.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5114_4257",
    x1: 248.926,
    y1: 45.9589,
    x2: 248.926,
    y2: 138.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5114_4257",
    x1: 249.047,
    y1: 46.1966,
    x2: 249.047,
    y2: 138.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7563,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5114_4257",
    x1: 249.183,
    y1: 46.4343,
    x2: 249.183,
    y2: 138.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5114_4257",
    x1: 249.318,
    y1: 46.6681,
    x2: 249.318,
    y2: 138.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B6B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5114_4257",
    x1: 249.469,
    y1: 46.9058,
    x2: 249.469,
    y2: 138.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5114_4257",
    x1: 249.625,
    y1: 47.1433,
    x2: 249.625,
    y2: 138.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B1B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5114_4257",
    x1: 249.778,
    y1: 47.3771,
    x2: 249.778,
    y2: 137.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFAFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5114_4257",
    x1: 249.944,
    y1: 47.6148,
    x2: 249.944,
    y2: 137.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8951,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADADAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5114_4257",
    x1: 250.107,
    y1: 47.8525,
    x2: 250.107,
    y2: 137.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAAAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5114_4257",
    x1: 250.282,
    y1: 48.0863,
    x2: 250.282,
    y2: 137.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8951,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5114_4257",
    x1: 250.46,
    y1: 48.324,
    x2: 250.46,
    y2: 137.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8951,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6A6A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5114_4257",
    x1: 250.634,
    y1: 48.5617,
    x2: 250.634,
    y2: 136.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5114_4257",
    x1: 250.819,
    y1: 48.7955,
    x2: 250.819,
    y2: 136.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8951,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5114_4257",
    x1: 250.998,
    y1: 49.0331,
    x2: 250.998,
    y2: 136.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8951,
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_5114_4257",
    x1: 251.189,
    y1: 49.2708,
    x2: 251.189,
    y2: 136.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_5114_4257",
    x1: 251.382,
    y1: 49.5046,
    x2: 251.382,
    y2: 136.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8951,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A9A9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_5114_4257",
    x1: 251.568,
    y1: 49.7423,
    x2: 251.568,
    y2: 135.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D9C9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8951,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989898"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_5114_4257",
    x1: 251.765,
    y1: 49.98,
    x2: 251.765,
    y2: 135.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_5114_4257",
    x1: 251.956,
    y1: 50.2177,
    x2: 251.956,
    y2: 135.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8951,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_5114_4257",
    x1: 252.157,
    y1: 50.4515,
    x2: 252.157,
    y2: 135.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919191"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_5114_4257",
    x1: 252.351,
    y1: 50.6891,
    x2: 252.351,
    y2: 135.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F8F8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_5114_4257",
    x1: 252.555,
    y1: 50.9268,
    x2: 252.555,
    y2: 134.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8C8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_5114_4257",
    x1: 252.76,
    y1: 51.1606,
    x2: 252.76,
    y2: 134.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A8A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_5114_4257",
    x1: 252.959,
    y1: 51.3983,
    x2: 252.959,
    y2: 134.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_5114_4257",
    x1: 253.167,
    y1: 51.6359,
    x2: 253.167,
    y2: 134.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_5114_4257",
    x1: 253.368,
    y1: 51.8697,
    x2: 253.368,
    y2: 134.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#838383"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_5114_4257",
    x1: 253.578,
    y1: 52.1074,
    x2: 253.578,
    y2: 133.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_5114_4257",
    x1: 253.789,
    y1: 52.3451,
    x2: 253.789,
    y2: 133.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_5114_4257",
    x1: 253.993,
    y1: 52.5788,
    x2: 253.993,
    y2: 133.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_5114_4257",
    x1: 254.207,
    y1: 52.8165,
    x2: 254.207,
    y2: 133.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7A7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_5114_4257",
    x1: 254.413,
    y1: 53.0542,
    x2: 254.413,
    y2: 133.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787878"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_5114_4257",
    x1: 254.628,
    y1: 53.288,
    x2: 254.628,
    y2: 132.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767676"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_5114_4257",
    x1: 254.843,
    y1: 53.5257,
    x2: 254.843,
    y2: 132.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_5114_4257",
    x1: 255.051,
    y1: 53.7634,
    x2: 255.051,
    y2: 132.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#747474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_5114_4257",
    x1: 255.268,
    y1: 54.0011,
    x2: 255.268,
    y2: 132.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6F6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_5114_4257",
    x1: 255.478,
    y1: 54.2349,
    x2: 255.478,
    y2: 132.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_5114_4257",
    x1: 255.696,
    y1: 54.4725,
    x2: 255.696,
    y2: 131.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_5114_4257",
    x1: 255.915,
    y1: 54.7102,
    x2: 255.915,
    y2: 131.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#686868"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_5114_4257",
    x1: 256.127,
    y1: 54.944,
    x2: 256.127,
    y2: 131.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_5114_4257",
    x1: 256.347,
    y1: 55.1817,
    x2: 256.347,
    y2: 131.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#656565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_5114_4257",
    x1: 256.559,
    y1: 55.4194,
    x2: 256.559,
    y2: 131.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#616161"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_5114_4257",
    x1: 256.78,
    y1: 55.6532,
    x2: 256.78,
    y2: 130.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F5F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_5114_4257",
    x1: 257.002,
    y1: 55.8909,
    x2: 257.002,
    y2: 130.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C5C5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_5114_4257",
    x1: 257.216,
    y1: 56.1288,
    x2: 257.216,
    y2: 130.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_5114_4257",
    x1: 257.438,
    y1: 56.3622,
    x2: 257.438,
    y2: 130.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#585858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_5114_4257",
    x1: 257.653,
    y1: 56.5999,
    x2: 257.653,
    y2: 130.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#565555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_5114_4257",
    x1: 257.876,
    y1: 56.8376,
    x2: 257.876,
    y2: 130.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#535353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_5114_4257",
    x1: 258.099,
    y1: 57.0714,
    x2: 258.099,
    y2: 129.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_5114_4257",
    x1: 258.315,
    y1: 57.3091,
    x2: 258.315,
    y2: 129.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F4F4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_5114_4257",
    x1: 258.54,
    y1: 57.5468,
    x2: 258.54,
    y2: 129.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C4C4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_5114_4257",
    x1: 258.757,
    y1: 57.7845,
    x2: 258.757,
    y2: 129.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A4A4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_5114_4257",
    x1: 258.981,
    y1: 58.0182,
    x2: 258.981,
    y2: 129.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_5114_4257",
    x1: 259.206,
    y1: 58.2559,
    x2: 259.206,
    y2: 128.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_5114_4257",
    x1: 259.424,
    y1: 58.4936,
    x2: 259.424,
    y2: 128.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_5114_4257",
    x1: 259.649,
    y1: 58.7274,
    x2: 259.649,
    y2: 128.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414141"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_5114_4257",
    x1: 259.868,
    y1: 58.9649,
    x2: 259.868,
    y2: 128.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_5114_4257",
    x1: 260.094,
    y1: 59.2028,
    x2: 260.094,
    y2: 128.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3C3C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5114_4257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 315,
    height: 303,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResult);
export default __webpack_public_path__ + "static/media/no-result.caa004fef580fdca46c13c315160d73a.svg";
export { ForwardRef as ReactComponent };